// Pure arbitration for the app-shell banner: decides which primary banner wins and
// how the BannerUpsellSlot is gated.
const isHomepage = (pathname) => pathname === '/';
const isHomeOrSearch = (pathname) => /(^\/$)|(^\/search)/.test(pathname);
/**
 * Primary App Banner priority: 1. Org invitation  2. Org billing  3. Promotions.
 *
 * Org invitation renders through the BannerUpsellSlot, so promo branches must
 * still yield to a pending invite (`!hasPendingOrgInvite`) — otherwise a
 * lower-priority promo would set hasPrimarySurfaceContent and suppress the
 * higher-priority invite, inverting the documented precedence.
 */
export const resolveAppBannerPlan = (input) => {
    let primary = null;
    if (input.canShowOrgBilling) {
        primary = 'org-billing';
    }
    else if (!input.hasPendingOrgInvite && isHomeOrSearch(input.pathname) && input.hasPartnerCode) {
        primary = 'partner';
    }
    else if (!input.hasPendingOrgInvite &&
        input.hasDiscountCode &&
        !input.hasAccessToProFeatures &&
        !input.hasPartnerCode) {
        primary = 'discount';
    }
    return {
        primary,
        upsell: {
            // Off the homepage, only fetch when an invite may exist. org-invitation is the
            // only banner allowed off-home today, and the homepage upsell endpoint
            // self-counts impressions/`shown` for whatever candidate it selects — so an
            // unconditional off-home fetch would burn caps/metrics for banners we never
            // render. If a second off-home banner is introduced, replace this
            // and the `non_home_non_org_invite` guard in useBannerUpsellSlotPlan with a
            // placement-scoped backend query.
            enabled: isHomepage(input.pathname) || input.hasPendingOrgInvite,
            hasPrimarySurfaceContent: primary != null,
        },
    };
};
//# sourceMappingURL=resolveAppBannerPlan.js.map